import { IVPlus, IVPlusData } from ".";

export class VPlus implements IVPlus {
    statusCode: number;
    message: string;
    data: string;

    constructor(data: IVPlusData){
        this.statusCode = data.statusCode;
        this.message = data.message;
        this.data = data.data;
    }

    dataFn(): IVPlusData {
        return Object.assign({}, this);
    }

}